import React from 'react';

const Terms = ({ terms }) => <div dangerouslySetInnerHTML={{ __html: terms }} />;

export default Terms;



// WEBPACK FOOTER //
// ./src/views/legal/Terms.js